import { Link } from 'react-router-dom'

import InternalErrorImage from '../../../images/internal-error.png'
import Logo from '../../logo'

import styles from './styles.module.scss'

const InternalError = () => {
  return (
    <div className={styles.main}>
      <div className={styles.logo}>
        <Logo isBlack={true} />
      </div>
      <img className={styles.image} src={InternalErrorImage} />
      <p className={styles.title}>Внутренняя ошибка сервера</p>
      <p className={styles.text}>
        Сервер не отвечает. Попробуйте зайти на страницу позже
      </p>
      <p className={styles.text}>Код ошибки: 500</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Link to={'/service'}>Сервисы</Link>
        </li>
        <li className={styles.item}>
          <Link to={'/upload'}>Загрузка данных</Link>
        </li>
        <li className={styles.item}>
          <Link to={'/settings'}>Настройки</Link>
        </li>
        <li className={styles.item}>
          <Link to={'/knowledge'}>База знаний</Link>
        </li>
      </ul>
    </div>
  )
}

export default InternalError
